var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "cookies-warning",
        size: "xl",
        "hide-header": "",
        "hide-footer": "",
        centered: "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        visible: _vm.showMsg,
      },
    },
    [
      _c(
        "div",
        { staticClass: "box-wrapper" },
        [
          _c("div", { staticClass: "text-wrapper" }, [
            _c("h6", { staticClass: "text-white mt-1 mb-2" }, [
              _vm._v("THIS WEBSITE USES COOKIES"),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "xxsmall" }, [
              _vm._v(
                "We use cookies for two reasons. First, we use cookies that are strictly necessary\n        for the operation and security of the website and second, we use cookies to identify you and\n        analyze our traffic provided that you have given your permission by checking the box\n        “Statistics”."
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkboxes mb-5" }, [
            _c(
              "div",
              {
                staticClass: "checkbox-wrapper disabled",
                on: {
                  click: function ($event) {
                    return _vm.alert(_vm.alertMsg)
                  },
                },
              },
              [
                _c("label", { attrs: { for: "necessary" } }, [
                  _c("span", { staticClass: "checkbox-text" }, [
                    _vm._v("NECESSARY"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cookies.necessary,
                        expression: "cookies.necessary",
                      },
                    ],
                    attrs: { id: "necessary", type: "checkbox", disabled: "" },
                    domProps: {
                      checked: Array.isArray(_vm.cookies.necessary)
                        ? _vm._i(_vm.cookies.necessary, null) > -1
                        : _vm.cookies.necessary,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.cookies.necessary,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.cookies,
                                "necessary",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.cookies,
                                "necessary",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.cookies, "necessary", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "checkbox" }),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "checkbox-wrapper" }, [
              _c("label", { attrs: { for: "statistics" } }, [
                _c("span", { staticClass: "checkbox-text" }, [
                  _vm._v("STATISTICS"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cookies.statistics,
                      expression: "cookies.statistics",
                    },
                  ],
                  attrs: { id: "statistics", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.cookies.statistics)
                      ? _vm._i(_vm.cookies.statistics, null) > -1
                      : _vm.cookies.statistics,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.cookies.statistics,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.cookies,
                              "statistics",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.cookies,
                              "statistics",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.cookies, "statistics", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "checkbox" }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "checkbox-wrapper" }, [
              _c("label", { attrs: { for: "advertising" } }, [
                _c("span", { staticClass: "checkbox-text" }, [
                  _vm._v("ADVERTISING"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.cookies.advertising,
                      expression: "cookies.advertising",
                    },
                  ],
                  attrs: { id: "advertising", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.cookies.advertising)
                      ? _vm._i(_vm.cookies.advertising, null) > -1
                      : _vm.cookies.advertising,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.cookies.advertising,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.cookies,
                              "advertising",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.cookies,
                              "advertising",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.cookies, "advertising", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "checkbox" }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex flex-column align-items-center" }, [
            _c(
              "button",
              {
                staticClass: "btn-accept-all mb-3",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.acceptAll()
                  },
                },
              },
              [_vm._v("ACCEPT ALL")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-accept-selected",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.acceptSelected()
                  },
                },
              },
              [_vm._v("ACCEPT ONLY SELECTED COOKIES")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-details",
                class: { active: _vm.details },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.toggleDetails()
                  },
                },
              },
              [_c("span", [_vm._v("MORE DETAILS")])]
            ),
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "height" } }, [
            _vm.details
              ? _c("div", { staticClass: "details" }, [
                  _c("div", { staticClass: "tabs" }, [
                    _c("div", { staticClass: "tabs-btns" }, [
                      _c(
                        "button",
                        {
                          staticClass: "tab-btn",
                          class: { active: _vm.tab === 1 },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.tab = 1
                            },
                          },
                        },
                        [
                          _vm._t("tab-1", function () {
                            return [_vm._v("COOKIE DECLARATION")]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "tab-btn",
                          class: { active: _vm.tab === 2 },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.tab = 2
                            },
                          },
                        },
                        [
                          _vm._t("tab-2", function () {
                            return [_vm._v("ABOUT COOKIES")]
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "tab-content" }, [
                      _vm.tab === 1
                        ? _c("div", { staticClass: "tabs-hor" }, [
                            _c("div", { staticClass: "tabs-hor-btns" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "tab-btn-hor",
                                  class: { active: _vm.tabHor === 1 },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.tabHor = 1
                                    },
                                  },
                                },
                                [_vm._v("NECESSARY")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "tab-btn-hor",
                                  class: { active: _vm.tabHor === 2 },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.tabHor = 2
                                    },
                                  },
                                },
                                [_vm._v("STATISTICS")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "tab-btn-hor",
                                  class: { active: _vm.tabHor === 3 },
                                  attrs: { type: "button" },
                                  on: {
                                    click: function ($event) {
                                      _vm.tabHor = 3
                                    },
                                  },
                                },
                                [_vm._v("ADVERTISING")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tab-content-hor" }, [
                              _vm.tabHor === 1
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "bar",
                                          rawName: "v-bar",
                                          value: { preventParentScroll: true },
                                          expression:
                                            "{preventParentScroll: true}",
                                        },
                                      ],
                                      staticClass: "h-100",
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "xxsmall text-left font-weight-book mb-3",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-underline-simple",
                                              },
                                              [_vm._v("Necessary cookies")]
                                            ),
                                            _vm._v(
                                              " are used to provide\n                      and protect our services while providing a swift and safer browsing experience\n                      by enabling basic functions like page navigation. The website cannot function\n                      properly without these cookies.\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table-md-responsive table-cookies",
                                            attrs: { id: "tb-necessary" },
                                          },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c("th", [
                                                  _vm._v("COOKIE NAME"),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("PURPOSE")]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("TYPE")]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("STORAGE")]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v("EXPIRATION"),
                                                ]),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c("td", [
                                                  _vm._v("showCookiesMsg"),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "Used to your cookie consent state for our domain."
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Technical")]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Optional")]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("1 month")]),
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("td", [
                                                  _vm._v("laravel_session"),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                            Used to create a session ID for the user, so that the system itself\n                            can identify you as a unique and individual user, distinct from\n                            anyone else looking at the website.\n                          "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Session")]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Necessary")]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Session")]),
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("td", [
                                                  _vm._v("XSRF-TOKEN"),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                            Used to enhance security of our Services and prevent repeated\n                            attempts as intrusions of our Services\n                          "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Technical")]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Necessary")]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Session")]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tabHor === 2
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "bar",
                                          rawName: "v-bar",
                                          value: { preventParentScroll: true },
                                          expression:
                                            "{preventParentScroll: true}",
                                        },
                                      ],
                                      staticClass: "h-100",
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "xxsmall text-left font-weight-book mb-3",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-underline-simple",
                                              },
                                              [_vm._v("Statistics cookies")]
                                            ),
                                            _vm._v(
                                              " help website owners\n                      to understand how visitors interact with websites by collecting and reporting\n                      information anonymously.\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table-md-responsive table-cookies",
                                            attrs: { id: "tb-statistics" },
                                          },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c("th", [
                                                  _vm._v("COOKIE NAME"),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("PURPOSE")]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("TYPE")]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("STORAGE")]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v("EXPIRATION"),
                                                ]),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c("td", [_vm._v("_ga")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                            Registers a unique ID that is used to generate statistical data on\n                            how the visitor uses the website.\n                          "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "Third-party (Google Tag Manager Google)"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Optional")]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("2 years")]),
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("td", [_vm._v("_gid")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                            Registers a unique ID that is used to generate statistical data on\n                            how the visitor uses the website.\n                          "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "Third-party (Google Tag Manager Google)"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Optional")]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("24 hours")]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tabHor === 3
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "bar",
                                          rawName: "v-bar",
                                          value: { preventParentScroll: true },
                                          expression:
                                            "{preventParentScroll: true}",
                                        },
                                      ],
                                      staticClass: "h-100",
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "xxsmall text-left font-weight-book mb-3",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-underline-simple",
                                              },
                                              [_vm._v("Advertising cookies")]
                                            ),
                                            _vm._v(
                                              " help website\n                      owners to understand how visitors interact with websites by collecting and\n                      reporting information anonymously.\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "table",
                                          {
                                            staticClass:
                                              "table-md-responsive table-cookies",
                                            attrs: { id: "tb-statistics" },
                                          },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c("th", [
                                                  _vm._v("COOKIE NAME"),
                                                ]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("PURPOSE")]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("TYPE")]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("STORAGE")]),
                                                _vm._v(" "),
                                                _c("th", [
                                                  _vm._v("EXPIRATION"),
                                                ]),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c("td", [_vm._v("_gcl_au")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "\n                            Used by Google AdSense for experimenting with advertisement efficiency across websites using their services"
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "The main purpose of this cookie is: Targeting/Advertising\n                          "
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "Third-party (Google Tag Manager Google)"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("Optional")]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("3 months")]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "h-100" }, [
                        _vm.tab == 2
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "bar",
                                    rawName: "v-bar",
                                    value: { preventParentScroll: true },
                                    expression: "{preventParentScroll: true}",
                                  },
                                ],
                                staticClass: "h-100",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-left py-2 px-4 xxsmall",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "\n                    We use cookies in this website, small text files with information on your\n                    navigation in this site, whose principal objective is to improve your experience\n                    in the website. In this webpage you shall find all the relevant information\n                    regarding the use of cookies in our website. We strongly recommend you to read\n                    through the following text from time to time as we might proceed with amendments\n                    in the future. For any question or clarification feel free to use our contact\n                    information or the contact form.\n                  "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }